import {Panel} from "components/Panel"
import {FormType} from "mixins/FormTypes"
import React, {createRef} from "react"
import Form from '../../mixins/form'
import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import AlertDanger from "../../components/Alerts/AlertDanger"
import {faArrowLeft, faRedo} from "@fortawesome/free-solid-svg-icons"
import {Http} from "../../mixins/http"
import AlertSuccess from "../../components/Alerts/AlertSuccess"
import {NavLink} from "react-router-dom"
import Trans from '../../components/Trans'

type RequestPasswordRequestProps = {}

type RequestPasswordRequestState = {
  form: FormType
}

class RequestPasswordRequest extends React.Component<RequestPasswordRequestProps, RequestPasswordRequestState> {
  private form: FormType = new Form({})
  private usernameRef = createRef<HTMLInputElement>()

  constructor(props: RequestPasswordRequestProps) {
    super(props)
    this.state = {
      form: this.form,
    }
  };

  sendPasswordResetLink = async (event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    const username = this.usernameRef.current ? this.usernameRef.current.value.split('.')[1] : null;
    const domain = this.usernameRef.current ? this.usernameRef.current.value.split('.')[0] : null;
    const form = new Form({
      username: username,
      domain: domain,
    })
    await this.setState({
      form: form
    })

    await Http.post('/password/email', {state: this, form: this.state.form})
  }

  render() {
    return (
      <div className="border-t-4 border-blue-800 overflow-y-scroll scrolling-smooth md:scrollbar  w-full h-full">
        <div className="flex flex-col p-2 w-full max-w-2xl lg:max-w-3xl mx-auto">
          <Panel>
            <div className="flex flex-col sm:flex-row flex-wrap w-full px-6 py-3">
              <div className="text-gray-600 font-semibold tracking-wide whitespace-no-wrap w-full lg:w-1/3 text-center sm:text-left">
                <Icon icon={faRedo}/>
                <span> <Trans>Passwort vergessen</Trans></span>
              </div>
              <form className="w-full lg:w-2/3 flex flex-col">
                {
                  this.state.form.successful ? (
                    <AlertSuccess><Trans>Wir haben Ihnen eine E-Mail gesendet, damit Sie ihr Passwort zurücksetzen können.</Trans></AlertSuccess>) : null
                }

                {
                  this.state.form.errors.has('user') ? (
                    <AlertDanger><Trans>Wir konnten keinen Benutzer mit dem eingegebenen Benutzernamen finden. Bitte Prüfen Sie dies und versuchen Sie es erneut.</Trans></AlertDanger>) : null
                }
                <div>
                  <label className="block tracking-wide text-gray-600 font-semibold mb-1"><Trans>Benutzername</Trans></label>
                  <input name="username" ref={this.usernameRef} type="text" placeholder="Benutzername" className="shadow appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300"/>

                  {
                    this.state.form.errors.has('username') || this.state.form.errors.has('domain') ?
                      <AlertDanger><Trans>Benutzername muss ausgefüllt sein. (Beispiel: firma.benutzername)</Trans></AlertDanger>
                      : null
                  }
                </div>

                <div className="mt-4 flex flex-row justify-between">
                  <div className="mt-4 flex justify-start">
                    <NavLink to='/login' className="text-gray-600 hover:text-blue-700 hover:font-semibold flex items-center mr-2 text-xs">
                      <Icon icon={faArrowLeft} className={'mr-1'}/>
                      <Trans>Zurück</Trans>
                    </NavLink>
                  </div>

                  <div className="mt-4 flex justify-end">
                    <button className={"rounded bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 font-semibold shadow" + (this.state.form.busy ? ' cursor-not-allowed ' : ' ')} disabled={this.state.form.busy} onClick={this.sendPasswordResetLink}>
                      {this.state.form.busy ?
                        <Icon icon="spinner" spin={true}/>
                        :
                        <Icon icon={faRedo}/>
                      }
                      <span> <Trans>Passwort zurücksetzen Link per E-Mail senden</Trans></span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </Panel>
        </div>
      </div>
    )
  }
}

export default RequestPasswordRequest
